import { useEffect, useState } from "react";
import Button from "../UI/Button";

const EMPTY_FORM = {
  site_name: "", tagline: "", whatsapp_number: "", email: "", instagram_url: "",
  tiktok_url: "", // Tambahan State TikTok
  address: "", hero_title: "", hero_subtitle: "", logo: "", favicon: "",
  primary_color: "", secondary_color: "", maps_embed_url: "",
};

const SiteSettingForm = ({ initialValues, onSubmit, loading = false }) => {
  const [form, setForm] = useState(EMPTY_FORM);

  useEffect(() => {
    if (initialValues) {
      setForm({
        site_name: initialValues.site_name || "",
        tagline: initialValues.tagline || "",
        whatsapp_number: initialValues.whatsapp_number || "",
        email: initialValues.email || "",
        instagram_url: initialValues.instagram_url || "",
        tiktok_url: initialValues.tiktok_url || "", // Mapping nilai TikTok
        address: initialValues.address || "",
        hero_title: initialValues.hero_title || "",
        hero_subtitle: initialValues.hero_subtitle || "",
        logo: initialValues.logo || "",
        favicon: initialValues.favicon || "",
        primary_color: initialValues.primary_color || "#8e1628", 
        secondary_color: initialValues.secondary_color || "#ec4899",
        maps_embed_url: initialValues.maps_embed_url || "",
      });
    } else {
      setForm(EMPTY_FORM);
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(form);
  };

  return (
    <>
      <style>
        {`
          .settings-grid { display: grid; gap: 30px; }
          .settings-section { background: #fffafc; padding: 24px; border-radius: 12px; border: 1px solid #fce7f3; }
          .settings-section-title { font-size: 1.1rem; color: #8e1628; font-weight: 800; margin-bottom: 20px; border-bottom: 2px solid #fbcfe8; padding-bottom: 8px; display: inline-block; }
          .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 16px; }
          .form-group { display: flex; flex-direction: column; gap: 6px; }
          .form-group.full { grid-column: 1 / -1; }
          .form-label { font-size: 13px; font-weight: 700; color: #4b5563; }
          .form-input, .form-textarea { width: 100%; padding: 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; transition: border 0.2s; outline: none; font-family: inherit; }
          .form-input:focus, .form-textarea:focus { border-color: #ec4899; box-shadow: 0 0 0 3px rgba(236,72,153,0.1); }
          .form-textarea { min-height: 100px; resize: vertical; }
          
          /* Color Picker Layout */
          .color-picker-wrapper { display: flex; align-items: center; gap: 10px; }
          .color-input { width: 45px; height: 45px; padding: 0; border: none; border-radius: 8px; cursor: pointer; overflow: hidden; }
          .color-input::-webkit-color-swatch-wrapper { padding: 0; }
          .color-input::-webkit-color-swatch { border: none; border-radius: 8px; }
          
          /* Image Preview */
          .img-preview-box { width: 60px; height: 60px; border-radius: 8px; border: 1px dashed #d1d5db; display: flex; align-items: center; justify-content: center; background: #fff; overflow: hidden; flex-shrink: 0; }
          .img-preview-box img { width: 100%; height: 100%; object-fit: contain; }
          
          @media (max-width: 768px) {
            .form-row { grid-template-columns: 1fr; }
          }
        `}
      </style>

      <form className="settings-grid" onSubmit={handleSubmit}>
        
        {/* SECTION 1: IDENTITAS */}
        <div className="settings-section">
          <h3 className="settings-section-title">📝 Identitas Website</h3>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nama Website</label>
              <input className="form-input" name="site_name" value={form.site_name} onChange={handleChange} placeholder="Misal: BukuOiBook" required />
            </div>
            <div className="form-group">
              <label className="form-label">Slogan / Tagline</label>
              <input className="form-input" name="tagline" value={form.tagline} onChange={handleChange} placeholder="Misal: Toko Buku Anak Edukatif" />
            </div>
          </div>
        </div>

        {/* SECTION 2: TAMPILAN & TEMA */}
        <div className="settings-section">
          <h3 className="settings-section-title">🎨 Tampilan & Tema</h3>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Logo URL</label>
              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <div className="img-preview-box">
                  {form.logo ? <img src={form.logo} alt="Logo" /> : <span style={{ fontSize: "20px", color: "#d1d5db" }}>🖼️</span>}
                </div>
                <input className="form-input" name="logo" value={form.logo} onChange={handleChange} placeholder="https://domain.com/logo.png" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Favicon URL (Ikon Tab)</label>
              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <div className="img-preview-box">
                  {form.favicon ? <img src={form.favicon} alt="Favicon" /> : <span style={{ fontSize: "20px", color: "#d1d5db" }}>🌍</span>}
                </div>
                <input className="form-input" name="favicon" value={form.favicon} onChange={handleChange} placeholder="https://domain.com/favicon.ico" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Warna Utama (Primary)</label>
              <div className="color-picker-wrapper">
                <input type="color" className="color-input" name="primary_color" value={form.primary_color} onChange={handleChange} />
                <input type="text" className="form-input" name="primary_color" value={form.primary_color} onChange={handleChange} placeholder="#8e1628" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Warna Sekunder (Aksen)</label>
              <div className="color-picker-wrapper">
                <input type="color" className="color-input" name="secondary_color" value={form.secondary_color} onChange={handleChange} />
                <input type="text" className="form-input" name="secondary_color" value={form.secondary_color} onChange={handleChange} placeholder="#ec4899" />
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3: HERO HOMEPAGE */}
        <div className="settings-section">
          <h3 className="settings-section-title">🚀 Hero Section (Halaman Depan)</h3>
          <div className="form-row">
            <div className="form-group full">
              <label className="form-label">Judul Utama (Hero Title)</label>
              <input className="form-input" name="hero_title" value={form.hero_title} onChange={handleChange} placeholder="DISCOVER THE MAGIC IN EVERY PAGE!" />
            </div>
            <div className="form-group full">
              <label className="form-label">Sub-Judul (Hero Subtitle)</label>
              <textarea className="form-textarea" name="hero_subtitle" value={form.hero_subtitle} onChange={handleChange} placeholder="Buka lembaran baru, mulai petualangan seru hari ini." />
            </div>
          </div>
        </div>

        {/* SECTION 4: KONTAK & LOKASI */}
        <div className="settings-section">
          <h3 className="settings-section-title">📞 Kontak & Lokasi Sosial</h3>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nomor WhatsApp (Awali dengan 62)</label>
              <input type="tel" className="form-input" name="whatsapp_number" value={form.whatsapp_number} onChange={handleChange} placeholder="628123456789" />
            </div>
            <div className="form-group">
              <label className="form-label">Email Publik</label>
              <input type="email" className="form-input" name="email" value={form.email} onChange={handleChange} placeholder="halo@bukuoibook.com" />
            </div>
            
            {/* PERBAIKAN: Media Sosial Berdampingan */}
            <div className="form-group">
              <label className="form-label">Instagram URL</label>
              <input type="url" className="form-input" name="instagram_url" value={form.instagram_url} onChange={handleChange} placeholder="https://instagram.com/bukuoibook" />
            </div>
            <div className="form-group">
              <label className="form-label">TikTok URL</label>
              <input type="url" className="form-input" name="tiktok_url" value={form.tiktok_url} onChange={handleChange} placeholder="https://tiktok.com/@bukuoibook" />
            </div>

            <div className="form-group full">
              <label className="form-label">Alamat Lengkap</label>
              <textarea className="form-textarea" name="address" value={form.address} onChange={handleChange} placeholder="Jl. Raya Depok No. 123..." />
            </div>
            <div className="form-group full">
              <label className="form-label">Google Maps Embed URL (Iframe src)</label>
              <textarea className="form-textarea" style={{ minHeight: "80px", fontFamily: "monospace", fontSize: "12px" }} name="maps_embed_url" value={form.maps_embed_url} onChange={handleChange} placeholder="https://www.google.com/maps/embed?pb=..." />
            </div>
          </div>
        </div>

        {/* SUBMIT BUTTON */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
          <Button type="submit" loading={loading} style={{ padding: "16px 40px", fontSize: "16px", borderRadius: "50px", backgroundColor: "#8e1628", color: "white", fontWeight: "800", border: "none", boxShadow: "0 10px 20px rgba(142, 22, 40, 0.2)" }}>
            {loading ? "Menyimpan..." : "💾 Simpan Semua Pengaturan"}
          </Button>
        </div>

      </form>
    </>
  );
};

export default SiteSettingForm;